import styled from 'styled-components'
import FlatButton from 'material-ui/FlatButton'
import images from '../../config/images'
import AppBar from 'material-ui/AppBar'
import {checkMobile,checkPad} from '../../lib'
export const HomeText = styled.span`
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 100%;
  letter-spacing: 0.571429px;
  color: #ffffff;
  opacity: 1;
`

export const LinkContainer = styled.div`
  display: flex;
  flex-direction: column-reverse;
`

export const NavigationContainer = styled.div`height: 4.875em;`

export const HomeButton = styled(FlatButton)`
  > div {
    display: flex;
    align-items: center;
  }
`

export const Right = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 70vh;
  left: 23vw;

  background: linear-gradient(
    270deg,
    #5c97f4 0%,
    rgba(67, 127, 225, 0.0001) 70.67%
  );
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.0874943);
  transform: rotate(-30deg);
`

export const Left = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  right: 10vw;
  top: 40vh;

  background: linear-gradient(
    275.01deg,
    #5291f5 23.71%,
    rgba(72, 134, 233, 0.0001) 94.28%,
    rgba(0, 131, 103, 0.0001) 95.66%
  );
  mix-blend-mode: normal;
  opacity: 0.47;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.0874943);
  transform: rotate(-165deg);
`

export const Bg = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0px;
  top: 0px;
  max-height: 100%;
  overflow: hidden;

  background: #4688f1;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.28), 0px 0px 4px rgba(0, 0, 0, 0.12);
`

export const BgDD = styled.div`
  width: 100%;
  height: auto;
  background: ${props => props.trial ? (checkMobile() ? `url(${images.fvlite_auto_trial_background_mobile})` : checkPad() ? `url(${images.fvlite_auto_trial_background_pad})` : `url(${images.fvlite_auto_trial_background})`) : `url(${images.fvlite_background})` };
  background-position: ${props => props.trial && (checkMobile() || checkPad()) ? '' : 'center'};
  background-repeat: no-repeat;
  background-size: ${props => (props.trial && checkMobile()) ? 'contain' : 'cover' };
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.28), 0px 0px 4px rgba(0, 0, 0, 0.12);
  min-height: 100% !important;
  position: absolute;
`
export const Header = styled(AppBar)`
  background: linear-gradient(279.27deg, #29A5F6 -235.04%, #4589F1 -116.41%, #4688F1 -113.4%),
  linear-gradient(91.6deg, #563FFB -31.42%, #26A9EF 13.73%, #83EFD3 68.54%);
  opacity: 1.00;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.24), 0px 0px 4px rgba(0, 0, 0, 0.12);
`


// WEBPACK FOOTER //
// src/layouts/LoggedOut/styles.js